const selectedTicket = (state = {}, action) => {
    switch (action.type) {
        case "SAVE_SELECTED_TICKET":
            return action.selectedTicket;
        default:
            return state;
    }
};

export default selectedTicket;
